<template>
  <div class="play-button">
    <a
      href="#"
      class="btn --large"
      @click.prevent="$emit('click')"
      id="pad-continue"
      pad-left="go:#pad-play"
      pad-right="go:#pad-news-1"
      pad-a="click"
    >
      <span class="btn__stroke"></span>
      <span class="btn__label">{{ $t("continue") }} <iconDisk /></span>
    </a>
  </div>
</template>

<script>
import iconDisk from "@/components/Icons/iconDisk";

export default {
  components: {
    iconDisk
  }
};
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
}

.btn.--large {
  margin: 0;

  &::after {
    background-color: $green;
  }
}

svg {
  margin-left: 5px;
}
</style>
